var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreathing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 74 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.6568 46.5546C64.5701 52.5546 58.1354 48.5546 55.3261 43.9799C50.4021 35.9586 50.5128 27.0172 37.0381 27.0172",
    stroke: "currentColor",
    strokeWidth: 4.75867,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.948 45.9854V49.0761C27.948 49.0761 27.6227 52.3587 24.8814 52.3587H11.796C7.86138 52.3587 5.81738 54.9894 5.81738 56.9027C5.81738 59.3814 9.69738 60.4774 11.9627 61.7721C11.9627 61.7721 39.9347 73.3374 44.948 74.1201",
    stroke: "currentColor",
    strokeWidth: 4.75867,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5139 45.9854V49.0761C44.5139 49.0761 44.8392 52.3587 47.5805 52.3587H60.6659C64.6005 52.3587 66.6445 54.9894 66.6445 56.9027C66.6445 59.3814 62.7645 60.4774 60.4992 61.7721C60.4992 61.7721 34.0379 71.8734 26.3525 74.1201",
    stroke: "currentColor",
    strokeWidth: 4.75867,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9489 10.836C44.9489 15.4467 41.2116 19.184 36.6009 19.184C31.9903 19.184 28.2529 15.4467 28.2529 10.836C28.2529 6.22537 31.9903 2.48804 36.6009 2.48804C41.2116 2.48804 44.9489 6.22537 44.9489 10.836Z",
    stroke: "currentColor",
    strokeWidth: 4.75867,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22559 46.5546C9.31225 52.5546 15.7469 48.5546 18.5563 43.9799C23.4803 35.9586 23.3696 27.0172 36.8443 27.0172",
    stroke: "currentColor",
    strokeWidth: 4.75867,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreathing);
export default __webpack_public_path__ + "static/media/breathing.4020c0b1d0ac3d2401efef6798ee0b40.svg";
export { ForwardRef as ReactComponent };